import React, { useState, useRef, useMemo, useEffect } from "react";
import {
  Box,
  Button,
  TextField,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Stack,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";

import DeleteIcon from "@mui/icons-material/Delete";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import FullscreenIcon from "@mui/icons-material/Fullscreen";


export default function Prompts(props) {
  const prompts = props.prompts || [];



  // ---------- RENDER ----------
 

  return (
    <>ToDo</>
  );
}
